export enum RoleEnum {
    Admin = 'admin',
    CompanyAdmin = 'company admin',
    Instructor = 'instructor',
    Student = 'student'
}